import { render, staticRenderFns } from "./SunheroThumbnailTile.vue?vue&type=template&id=68aaef64&scoped=true"
import script from "./SunheroThumbnailTile.vue?vue&type=script&lang=js"
export * from "./SunheroThumbnailTile.vue?vue&type=script&lang=js"
import style0 from "./SunheroThumbnailTile.vue?vue&type=style&index=0&id=68aaef64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aaef64",
  null
  
)

export default component.exports